(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:MessageService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('MessageService', MessageService);

    function MessageService(toastr) {
        var self = this;

        self.MESSAGES = {};
        self.MESSAGES.COMMON = {
            NO_RECORDS_FOUND: 'No Records found for the given criteria',
            SYSTEM_ERROR:'Contact system administrator',
            CONFIRM_CONTINUE : 'Do you wish to continue ?',
            UNKNOWN_ERROR : 'Error occured. Please Contact system administrator',
            SUCCESS_SAVED: 'Record successfully added.',
            UNDO_SUCCESS: 'Undo the operations for crew',
            DELETE_SUCCESS:'Successfully deleted'
        };
        self.MESSAGES.CREWING = {
            DUTY_REMOVE_SUCCESS : 'Duty Removed Successfully',
            DUTY_REMOVE_FAILED : 'Duty Removed Unsuccessful',
            DUTY_REMOVE_SUCCESS_WITH_ILLEGAL_WARNING : 'Duty Removed Successfully, other duties became illegal',
            DUTY_MOVE_SUCCESS : 'Duty Successfully Moved',
            DUTY_COPY_SUCCESS : 'Duty Successfully Copied',
            ASSIGN_PAIRING_SUCCESS :'Assign pairing successful',
            ASSIGN_PAIRING_WARNING :'Select pairing to continue',
            ASSIGN_EVENT_SUCCESS : 'Event successfully assigned',
            ASSIGN_LEAVE_SUCCESS : 'Leave Successfully assigned',
            ASSIGN_OFF_SUCCESS : 'Off successfully assigned',
            ASSIGN_VULV_SUCCESS : 'VULV successfully assigned',
            ASSIGN_CNT_SUCCESS : 'CNT successfully assigned',
            ASSIGN_SOH_SUCCESS : 'SOH successfully assigned',
            ASSIGN_CSD_SUCCESS : 'Cabin Special duty successfully assigned',
            ASSIGN_CSA_SUCCESS : 'Cabin Support Activity successfully assigned',
            ASSIGN_AVL_SUCCESS : 'Available Rest successfully assigned',
            ASSIGN_SICK_LEAVE_SUCCESS : 'Sick leave successfully assigned',
            ASSIGN_ANNUAL_LEAVE_SUCCESS : 'Annual leave successfully assigned',
            ASSIGN_BLOCK_DAYS_SUCCESS : 'Block days successfully assigned',
            ASSIGN_TRAINING_SUCCESS : 'Training successfully assigned',
            ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL : 'Other blocks became illegal',
            ASSIGN_BULK_TRAINING_FAILED : 'Training assignment failed for some crew/s',
            TRAINING_CONFLICT_WITH_CREW_REQUEST : 'Crew Request(s) Available. Do You Wish To Continue ?',
            TRAINING_CONFLICT_EXIST : 'Conflict Records Exist',
            TRAINING_CONFLICT_EXIST_DESC : 'Training Program has already been scheduled',
            TRAINING_DETAILS_UPDATE_SUCCESS : 'Training details successfully updated',
            TRAINING_EXPIRY_WARNING : 'Training program ',
            TRAINING_EMPTY_SEARCH_RESULT : 'No unassigned crew / pending crew expiries found',
            ADD_MEMO_SUCCESS : 'Memo successfully added',
            DELETE_MEMO_SUCCESS : 'Memo successfully deleted',
            SCHEDULE_PUBLISHED_SUCCESS : 'Schedule successfully published',
            SCHEDULE_EMAIL_SUCCESS : 'Crew schedule successfully emailed',
            UPDATE_SUCCESS : 'Successfully updated',
            UPDATE_FAIL : 'Update operation failed',
            NO_SELECTION_WARNING : 'Make a selection to proceed',
            INACTIVE_CREW_WARNING : 'Crew is inactive',
            NOT_UPDATABLE_EVENT:'Selected event not updatable',
            NOT_SELECT_EVENT:'Please select the Event Type.',
            NO_REGULATIONS_FOR_LEAVES : 'No Regulation(s) found for Leave category.',
            ADD_EVENT_START_DATE_TIME_ERROR:' Start Date/Time cannot be blank.',
            ADD_EVENT_END_DATE_TIME_ERROR:' End Date/Time cannot be blank.',
            END_DATE_TIME_LESS_THAN_START_DATE_TIME:'End Date/Time cannot be less than Start Date/Time.',
            START_LOCATION_ERROR:'Please select the Start Location.',
            START_LOCATION_ERROR2:'Please select the Start Location from the given list',
            END_LOCATION_ERROR:'Please select the End Location ',
            END_LOCATION_ERROR2:'Please select the End Location from the given list',
            AIRCRAFT_ERROR:'Please select the Aircraft Type.',
            SCHEDULE_NOT_PUBLISH:'Published Schedule not found.',
            MESSAGE_EMPTY_CONTENT:' Message Content cannot be blank.',
            SUCCESS_SAVE_MESSAGE:'Record(s) successfully saved.',
            BLOCK_NOT_PART_OF_A_PATTERN : 'The selected block is not part of a pattern. Please select a pattern block.',
            EDIT_BLOCK_ERROR_01:'Checkin Date/Time should be less than or equal to Block Start Time.',
            EDIT_BLOCK_ERROR_02:'Checkout Date/Time should be greater than or equal to Block end time.',
            OPERATION_NOT_SUPPORTED_FOR_MULTIPLE_BLOCKS : 'Operation not supported for multiple selection',
            NO_RESULT_FOR_FILTER : 'No Crew(s) found with matching filter criteria',
            INCORRECT_TIME  : 'End Date/Time cannot be less than Start Date/Time.',
            CREW_PORTAL_HIDE: 'Do you want hide this change in crew portal?',
            CREW_SCHEDULE_NOT_LOADED: 'Crew schedule is not loaded.',
            CREW_SCHEDULE_NOT_PUBLISHED: 'Crew schedule is not published.',
            SHOW_ALL_IN_CREW_PORTAL: 'Show all Pending Items in Crew Portal',
            CREW_REQUIREMENT_EXCEEDS:"Crew Assigned is greater than Crew Required. Do you wish to continue? " ,
            PIC_CREW_EXIST: "Following PIC crew is already exist. Do you want to continue? ",
            CREW_PROBATION_OVERRIDE: "Crew member is on probation. Do you want to continue with leave assignment?",
            DUTY_OVERLAPPING: "Overlapping Duty. Do you want to replace the existing duty?",
            DUTY_ACKNOWLEDGE_SUCCESS : 'Duty Acknowledged Successfully',
            DUTY_ACKNOWLEDGE_FAILED : 'Duty Acknowledge Unsuccessful',
            PREVIOUS_DUTY_END_BASE_IS_DIFFERENT_FROM_THE_NEXT_DUTY_START_BASE: "Previous duty end Base is different from this duty start base. Do you wish to continue? ",
            CONVERTING_BACK_TO_SICK_SUCCESS : 'Duty Converted to SLV Successfully',
            CONVERTING_BACK_TO_SICK_FAILED : 'Duty Conversion Unsuccessful',
            MULTIPLE_SELECTED_TYPES_TRAINER_TRAINEE_UPDATE : 'Please select one category.(Flight/Training)',
            ASSIGN_WFD_SUCCESS : 'WFD successfully assigned',
            ASSIGN_AWB_SUCCESS : 'AWB successfully assigned',
            ASSIGN_LIM_SUCCESS : 'LIM successfully assigned',
            AIRPORT_RECENCY_VIOLATED : 'Airport recency violated for the selected crew member(s). Do you wish to override?',
        };
        self.MESSAGES.FLIGHT ={
            UPDATE_FLIGHT_SUCCESS :'Record(s) successfully saved.',
            ACTUAL_PAX_ALREADY_UPATED_FROM_SOURCE:'Actual Passenger information is already updated from highest priority source',
            UPDATE_FLIGHT_CANCEL_OR_REINSTATE_SUCCESS:'Record(s) successfully updated.',
            UPDATE_FLIGHT_APPROACH_CON_EMPTY :'Please select Approach Condition.',
            UPDATE_FLIGHT_APPROACH_TYPE_EMPTY :'Please select Approach Type',
            UPDATE_FLIGHT_SUPPLIER_EMPTY :'Please select Supplier',
            UPDATE_FLIGHT_APPROACH_TYPE_ONLY :'Approach Type cannot be selected before Touch down.',
            UPDATE_FLIGHT_APPROACH_CON_ONLY :'Approach Condition cannot be selected before Touch down.',
            UPDATE_FLIGHT_FORM_NOT_TOUCH:'No Change(s) Found!',
            ATA_ATD_NULL:'Please enter ATD and ATA to select take off and landing crew.',
            MOVEMENT_ERROR_1:  "ATD Date and ATD Time cannot be blank.",
            MOVEMENT_ERROR_2:  'TOFF Date and TOFF Time cannot be blank.',
            MOVEMENT_ERROR_3:  'ATA Date and ATA Time cannot be blank.',
            MOVEMENT_ERROR_4:  'TDOWN Date and TDOWN Time cannot be blank.',
            MOVEMENT_ERROR_5:  'RSTD Date or RSTD Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_6:  'RSTA Date or RSTA Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_7:  'ATD Date or ATD Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_8:  'TDOWN Date or TDOWN Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_9:  'TOFF Date or TOFF Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM)',
            MOVEMENT_ERROR_10:  'ATA Date or ATA Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_11 : "TOFF Date and TOFF Time cannot be less than ATD Date and ATD Time.",
            MOVEMENT_ERROR_12 : "TDOWN Date and TDOWN Time cannot be less than TOFF Date and TOFF Time.",
            MOVEMENT_ERROR_13 : "ATA Date and ATA Time cannot be less than TDOWN Date and TDOWN Time.",
            MOVEMENT_ERROR_14 : "Delay Time or Delay Code cannot be blank.",
            MOVEMENT_ERROR_14_D : "Departure Delay Time or Delay Code cannot be blank.",
            MOVEMENT_ERROR_14_A : "Arrival Delay Time or Delay Code cannot be blank.",
            MOVEMENT_ERROR_15 : "Please remove Departure delay reasons for the Departure delay (ATD - STD).",
            MOVEMENT_ERROR_16 : "Please enter Departure delay reasons for the Departure delay (ATD - STD).",
            MOVEMENT_ERROR_17 : "Please remove Arrival delay reasons for the Arrival delay (ATA - STA).",
            MOVEMENT_ERROR_18 : "Please enter Arrival delay reasons for the Arrival delay (ATA - STA).",
            MOVEMENT_ERROR_19 : 'Arrival Diversion Information cannot be blank.',
            MOVEMENT_ERROR_20 : 'Diversion ATD Date and Diversion ATD Time cannot be less than ATA Date and ATA Time.',
            MOVEMENT_ERROR_21 : 'Diversion TOFF Date and Diversion TOFF Time cannot be less than ATD Date and Diversion ATD Time.',
            MOVEMENT_ERROR_22 : 'Diversion TDOWN Date and Diversion TDOWN Time cannot be less than Diversion TOFF Date and Diversion TOFF Time.',
            MOVEMENT_ERROR_23 : 'Diversion ATA Date and Diversion ATA Time cannot be less than Diversion TDOWN Date and Diversion TDOWN Time.',
            MOVEMENT_ERROR_24 : 'Diversion TDOWN Date or Diversion TDOWN Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_25 : 'Diversion ATA Date or Diversion ATA Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_26 : 'Diversion ATD Date or Diversion ATD Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_27 : 'Diversion TOFF Date or Diversion TOFF Time format is incorrect. Please enter date in (DD/MM/YYYY) and time in (HH:MM).',
            MOVEMENT_ERROR_28 : 'Aircraft Model mismatched',
            MOVEMENT_ERROR_29 : 'Invalid time format.Please enter in minutes.',
            MOVEMENT_ERROR_30 : 'Please enter Diversion Arrival Airport.',
            MOVEMENT_ERROR_31 : 'Either Arrival Timings (ATA and TDOWN) or Continued to the scheduled destination is Required.',
            MOVEMENT_ERROR_32:  "RSTD Date and RSTD Time cannot be blank.",
            MOVEMENT_ERROR_33:  "RSTA Date and RSTA Time cannot be blank.",
            ADD_CHECKS_2 : 'Please Select Registration Number.',
            ADD_CHECKS_1 : 'Please select a Aircraft',
            RELOAD_ERROR:'Commit your current changes and reload',
            ERROR_ADD_CHECK:'End Date and End Time cannot be less than Start Date and Start Time',
            NO_SUPPLIERS_FOUND: 'No fuel suppliers found in this station',
            EMAIL_SENT_SUCCESS: 'Emails successfully Sent',
            SEARCH_BEFORE_CHECK_SUMMARY : 'Please Search Before Check Rotation Summary',
            FULL_SCHD_ROTATION_SUCCESS : 'Full Schedule Rotation Is Successfull',
            ATC_ADHOC_CALL_SIGN_LENGTH : 'Length of ATC AdHoc call sign should be 4',
            ATC_ADHOC_CALL_SIGN_CHARACTERS : 'Only Alphabets and Numbers allowed for ATC AdHoc call sign'
        };
        self.MESSAGES.CREATE_PAIRING = {
            FILL_MANDATORY: 'Enter Required information to proceed',
            CHECK_FDP_ENTRY: 'Check FDP entries',
            CREATED_PAIRING_SUCCESS :'Pairing created successful',
            TRAINING_ERROR_01:'Please select the Training Program.',
            TRAINING_ERROR_02:'Please select the Program Detail.',
            LANG_REQUREMENT:'Language requerment not valid with cabin crew requerment.',
            CLOSE_PAIRING_TABS: 'Pairing Successfully Updated. Do you wish to close tab?',
            TRAVEL_REQUEST_OVERRIDDEN_SUCCESS: 'Staff Travel Request successfully Overridden',
            BULK_UPDATE_PAIRING_SELECTION_MISSING: 'Minimum one pattern should be select to update.',
            BASE_MISSING: 'Origin does not match with any base. Please select base.',
            NO_TRAINING_FOUND: 'No Trainings found for the given criteria',
            NO_FLIGHTS_FOUND: 'No Flights found for the given criteria',
            ACMI_OPERATION_WITHOUT_ACMI_TYPE: 'No ACMI Type Selected for ACMI Operation',
            REMARKS_REQUIRED: 'Please fill in the mandatory sections to proceed.',
            REMARKS_NOT_SELECTED: 'Please select change reason type to proceed.'
        };
        self.MESSAGES.CREW_SCHEDULE ={
            ADD_NOTE_SUCCESS : 'Note successfully added.',
            EDIT_NOTE_SUCCESS : 'Note successfully edited.',
            DELETE_NOTE_SUCCESS: 'Note successfully deleted.',
            SEARCH_VALIDATION_ERROR:'Please select Crew Name or enter Crew ID.',
            SYNC_TRAINING_STAGE_SUCCESS : 'Training Stage successfully synced',
            SYNC_TRAINING_STAGE_FAILED : 'Training Stage sync failed',
        };
        self.MESSAGES.CREW_PROFILE ={
            EDIT_SUCCESS :'Record(s) successfully saved.',
            DELETE_SUCCESS:'Record(s) successfully deleted.',
            ERROR_SEARCH:'Please enter Crew Name or Crew ID.',
            IMPORT_SUCCESS:'Other Hub Hour Record(s) Successfully Imported.',
            BASE_UPDATE_CONFIRMATION_ASSIGNMENTS_EXIST:'There are duties assigned in the base assignment period. Are you sure to continue?',
            BASE_UPDATE_CONFIRMATION_ASSIGNMENTS_DOESNT_EXIST:'No duties assigned in the base assignment period. Proceed?',
            ERROR_ACMI_START_DATE_NOT_SELECTED: 'Please update the ACMI start date.',
            TRAINING_STAGE_COMPLETION_UPDATE_SUCCESS : 'Training Stage Completion Status Successfully Updated',
            TRAINING_STAGE_COMPLETION_UPDATE_FAILED : 'Training Stage Completion Status Update Failed',
        };
      self.MESSAGES.ANNUAL_LEAVE_BID ={
        UPLOAD_SUCCESS :'CSV File Successfully Saved and Leave Update Start.',
        UPADTE_ON_PROGRESS:'Leave Bulk Update Still in Progress. Search after some time.',
        RESPONSE_SUCCESS:'Leave Records Successfully Saved',
        RESPONSE_CLICK_BEFORE_UPLOAD_FILE:'Need to be upload file first.'
      };
        self.MESSAGES.TRAINING_SCHEDULE ={
            TRAINER_TRAINEE_NOT_SELECT:'Trainer / Trainee Allocation type not selected.',
            TRAINER_REMOVE_SUCCESS : 'Removed Successfully',
            TRAINER_REMOVE_FAILED : 'Duty Removed Unsuccessful',
            PARENT_HUB_TRAINING_DELETED: 'Attention: Parent Hub Training has been Deleted / Cancelled.'
        };

        self.MESSAGES.TRACKING = {
            ASSIGN_CREW_TO_PAIRING_SUCCESS : 'Crew Successfully Assigned',
            ASSIGN_CREW_OTHER_BLOCKS_ILLEGAL : 'Other blocks became illegal',
            TRACKING_SWAPP_CREW_SUCCESS : 'Swap Operation successfull',
            DISCREPANCY_CREW_TYPE_SELECTION_CONSTRAIN : 'At least one crew type has to be selected',
            DISCREPANCY_LANG_TYPE_SELECTION_CONSTRAIN : 'At least one langugae code has to be selected'
        };

        self.MESSAGES.TRAINING_PROGRAME = {
            DELETE_SUCCESS:'Successfully deleted',
            RESYNC_SUCCESS:'Successfully Synced',
            SUCCESS_SAVE:'Saved successfully!',
            ENDDATE_STARTDATE_CONFLICTS: 'End date and time cannot be lesser than start date and time',
            ENDTIME_STARTTIME_CONFLICTS: 'End Time should be grater than the start time',
            UNASSIGN_SUCCESS: 'Crew successfully unassigned',
            VALIDATION_ERROR: 'Validation failure!',
        };

      self.MESSAGES.TRAINING_PROGRAME_AUTOMATION = {
        DELETE_SUCCESS:'Successfully deleted',
        SUCCESS_SAVE:'Saved successfully!',
        ENDDATE_STARTDATE_CONFLICTS: 'End date and time cannot be lesser than start date and time',
        ENDTIME_STARTTIME_CONFLICTS: 'End Time should be grater than the start time',
        UNASSIGN_SUCCESS: 'Crew successfully unassigned',
        ASSIGN_SUCCESS: 'Crew successfully assigned',
        INVALID_INPUT:'Please select one or more Training Automation records',
        DELETE_DISTRIBUTION_SUCCESS:'Successfully deleted the training distribution.',
      };

        self.MESSAGES.DOCUMENT_MANAGER = {
            DELETE_SUCCESS: 'Successfully deleted',
            SUCCESS_SAVE: 'Successfully Uploaded',
        };

        self.MESSAGES.PAYMENT_RATES = {
    		ERROR_SEARCH:'Please enter Crew Type.',
    		POPUP_FORM_ERROR:'Please fill out all the fields',
    		RANGE_NAME_EXISTS:'Entered range name exists please try with other name',
    		DELETE_CONFIRMATION:"Selected record will be Deleted. Do you wish to Continue?",
			DELETE_SUCCESS: 'Successfully deleted',
			DELETE_CANCEL : 'Deletion cancelled',
			INVALID_RANGE_HOUR : 'To hour cannot be less than From hour'
        };
        self.MESSAGES.CABIN_FLIGHT_ADMIN = {
    		DELETE_CONFIRMATION:"Selected record will be Deleted. Do you wish to Continue?",
			DELETE_SUCCESS: 'Successfully deleted',
			APPROVE_CONFIRMATION:"Selected record will be Approved. Do you wish to Continue?",
			APPROVE_SUCCESS: 'Successfully approved',
            REMARK_DELETE_CONFIRMATION:"Selected remark will be Deleted. Do you wish to Continue?",
            REMARK_DELETE_SUCCESS: 'Remark successfully deleted'
        };
        self.MESSAGES.OTHER_HUB_HOURS = {
        		DELETE_CONFIRMATION:"Selected Record(s) Will Be Deleted. Do You Wish To Continue?",
    			DELETE_SUCCESS: 'Successfully Deleted',
    			UPDATE_SUCCESS: 'Successfully Updated'
        };
        self.MESSAGES.LAYOVER_ACCOMMODATION_PREFERENCE = {
            DELETE_CONFIRMATION:"Selected Record(s) Will Be Deleted. Do You Wish To Continue?",
          DELETE_SUCCESS: 'Successfully Deleted',
          UPDATE_SUCCESS: 'Successfully Updated'
        };
        self.MESSAGES.SEND_NOTIFICATION = {
            NOTIFICATION_SEND_SUCCESS:"Notification has been send successfully",
            NOTIFICATION_SEND_FAIL :"Error occurred while sending notification",
            NOTIFICATION_NOT_CHECKED_ANY :"No notification(s) has been selected"

        };
      self.MESSAGES.SALES_TARGET ={
        UPLOAD_SUCCESS :'CSV File Successfully Saved.'
      };

        self.success = function (msg) {
            showMessage(msg,'success');
        };

        self.error = function (obj) {
            showMessage(obj,'error');
        };

        self.warning = function (msg) {
            showMessage(msg,'warning');
        };

        function showMessage(obj,type){
            if(typeof obj == 'string'){
                toastr[type].call(this,obj);
            }else if(typeof obj == 'object'){
                var msg = obj.msg;
                if(!!msg){
                    if(msg instanceof  Array){
                        if(Array && msg.length > 1){
                            var tmp = '';
                            angular.forEach(msg,function(msgString){
                                tmp += '<span>'+msgString+'</span>';
                            });
                            toastr[type].call(this,tmp);
                        }else{
                            toastr[type].call(this,msg[0]);
                        }
                    }else{
                        toastr[type].call(this,msg);
                    }
                }else{
                    toastr[type].call(this,'Error!');
                }
            }
        }
    }
}());
